import {
  FontIcon,
  FontSizes,
  Label,
  NeutralColors,
  Panel,
  PanelType,
  Stack,
  getTheme,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";
import { ITablaGruposDocumentos } from "../../../Interfaces/gestionDocumentos/IGrupoDocumento";

interface IPanelPanelEliminarDocumentos {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  archivosId: ITablaGruposDocumentos[];
  setSelectedItems: React.Dispatch<
    React.SetStateAction<ITablaGruposDocumentos[]>
  >;
  selectedItems: ITablaGruposDocumentos[];
}
export const PanelEliminarDocumentos = (
  props: IPanelPanelEliminarDocumentos
) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [archivosId, setarchivosId] = useState<ITablaGruposDocumentos[]>([]);
  const theme = getTheme();

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      validarForm();
      setarchivosId(props.archivosId);
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [archivosId, props.isOpen]);

  const validarForm = () => {
    if (archivosId == null) setDisableForm(true);
    if (archivosId !== null) {
      if (archivosId.length > 0) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            {"Eliminar Documentos"}
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    [props.isOpen]
  );

  const _confirmar = () => {
    setIsSend(true);
    setDisableForm(true);
    setIsContenedor(true);
    grupoDocumentoService
      .deleteDocumentosMasivo(archivosId.map((i) => i.archivoId))
      .then((res) => {
        if (res.status === 200) {
          setIsSend(false);

          if (res.data.confirmacion) {
            setIsSaccesfull(true);
            setMensaje(res.data.mensaje);
            props.setSelectedItems([]);
            props.onRenderTable();
            setarchivosId([]);
            //Clone Panel After one second
            setTimeout(() => {
              _goback();
            }, 1000);
          } else {
            setIsError(true);
            setMensajeError(res.data.mensaje);
          }
        }
      })
      .catch((err: Error) => {
        setIsSend(false);
        setIsError(true);
        setMensajeError("No se puedo Eliminar los Documentos");
      });
  };

  const updateSelectedItems = (
    arr: ITablaGruposDocumentos[],
    deleted: ITablaGruposDocumentos[]
  ): ITablaGruposDocumentos[] => {
    let newArray: ITablaGruposDocumentos[] = [];

    for (let i = 0; i < deleted.length; i++) {
      newArray = arr.filter(
        (a) => a.archivoId.toUpperCase() != deleted[i].archivoId.toUpperCase()
      );
    }

    return newArray;
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Eliminar"
          texto2={"Cancelar"}
          disableButton={disableForm}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
        />
      </>
    ),
    [disableForm, props.archivosId]
  );

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setarchivosId([]);
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };
  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
    >
      <>
        <br />
        {/* <pre>{JSON.stringify(archivoId, null, 2)}</pre> */}

        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}

        <div hidden={isContenedor}>
          <Stack>
            <Stack.Item
              grow={3}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {/* <pre>{JSON.stringify(archivosId, null, 2)}</pre> */}
              <div
                style={{
                  display: "flex",
                  // border: "solid 1px red",
                  // justifyContent: "space-between",
                  marginBottom: "15px",
                }}
              >
                <div>
                  <FontIcon
                    iconName="Warning"
                    style={{
                      color: theme.palette.orangeLight,
                      fontSize: 30,
                      height: 35,
                      width: 35,

                      // margin: "0 5px",
                    }}
                  />
                </div>

                <div style={{ marginLeft: "15px" }}>
                  <span
                    style={{
                      fontSize: "15px",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  >
                    ¿Desea eliminar los Documentos?
                  </span>
                  <span
                    style={{
                      fontSize: "15px",
                      marginBottom: "15px",
                      display: "block",
                    }}
                  >
                    Una vez confirmado, esta acción no se podrá deshacer.
                  </span>

                  <div style={{ marginTop: "50px" }}>
                    <Documento lista={archivosId} />
                  </div>
                </div>

                {/* <span style={{ marginLeft: "50px" }}>
                  Una vez confirmado, esta acción no se podrá deshacer.
                </span> */}
              </div>
            </Stack.Item>
          </Stack>
        </div>
        <br />
        <br />
      </>
    </Panel>
  );
};

const Documento = ({ lista }: { lista: ITablaGruposDocumentos[] }) => {
  return (
    <>
      <div
        key={"listaDocsGD"}
        style={{ display: "flex", flexDirection: "column", rowGap: "5px" }}
      >
        {lista.map((documento, i) => {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  border: "solid 1px rgb(237, 235, 233)",
                  padding: "5px",
                  alignItems: "center",
                }}
                key={i}
              >
                <img
                  src={
                    "https://res-1.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/item-types/16/pdf.svg"
                  }
                  style={{
                    verticalAlign: "middle",
                    maxHeight: "20px",
                    maxWidth: "20px",
                  }}
                  alt={` folder icon`}
                />

                <span style={{ marginLeft: "10px", fontSize: "12px" }}>
                  {documento.nombreArchivo &&
                  documento.nombreArchivo.length <= 40
                    ? documento.nombreArchivo
                    : documento.nombreArchivo!.substring(0, 40 - 3) + "..."}
                </span>
              </div>
              {/* rgb(237, 235, 233) */}
            </>
          );
        })}
      </div>
    </>
  );
};
